import { useMarketplaceItems } from '@/apis/marketplace/hooks/useMarketplaceItems'
import { MarketplaceItem } from '@/apis/marketplace/marketplace.schema'
import { useApplicantProgramYears } from '@/app/SchoolYearProvider'
import MultiQueryPageLoader from '@/app/common/components/PageLoader/MultiQueryPageLoader'
import { usePagination } from '@/common/hooks/usePagination.tsx'
import { AppRoutePaths } from '@/routing/route_paths'
import { useDebounce } from '@uidotdev/usehooks'
import { useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import AffiliationItems from './AffiliationItems'
import { TABLE_FILTERS } from '@/app/pages/marketplace/constants'

export default function AffiliationDetailPage() {
  const navigate = useNavigate()
  const { affiliationId } = useParams()
  const { selectedProgramId } = useApplicantProgramYears()
  const { currentPage, perPage, setCurrentPage, setPerPage } = usePagination()

  const [search, setSearch] = useState('')
  const [selectedFilter, setSelectedFilter] = useState<string>('')

  const debouncedSearch = useDebounce(search, 500)
  const parsedAffiliationId = Number(affiliationId)

  const itemsQuery = useMarketplaceItems(
    selectedProgramId,
    selectedFilter,
    debouncedSearch,
    undefined,
    parsedAffiliationId,
    perPage,
    currentPage,
    {
      enabled:
        selectedProgramId != null &&
        Number.isFinite(parsedAffiliationId) &&
        parsedAffiliationId > 0,
    }
  )

  const totalRecords = itemsQuery.data?.total ?? 0
  const items = itemsQuery.data?.data ?? []

  const handleFilterOnChange = (item: { id: number; name: string }) => {
    setSelectedFilter(
      item.id == 0 ? '' : item.id == 1 ? '1,2' : item.id.toString()
    )
    setCurrentPage(1)
  }

  const handleItemClick = (item: MarketplaceItem) => {
    navigate(
      AppRoutePaths.marketplace.details.index.replace(
        ':itemId',
        item.id.toString()
      )
    )
  }

  const handleBack = () => {
    navigate(AppRoutePaths.marketplace.index)
  }

  if (!Number.isFinite(parsedAffiliationId) || parsedAffiliationId <= 0) {
    return (
      <div className="text-center text-gray-500 py-10">
        Affiliation not found.
      </div>
    )
  }

  return (
    <MultiQueryPageLoader queries={[itemsQuery] as const}>
      {() => {
        return (
          <AffiliationItems
            items={items}
            totalRecords={totalRecords}
            search={search}
            filters={TABLE_FILTERS}
            currentPage={currentPage}
            perPage={perPage}
            onSearchChange={setSearch}
            onFilterChange={handleFilterOnChange}
            onItemClick={handleItemClick}
            onBack={handleBack}
            onPageChange={setCurrentPage}
            onPerPageChange={setPerPage}
          />
        )
      }}
    </MultiQueryPageLoader>
  )
}
